<div class="p-grid w-100">
	<div class="p-col-12 p-md-4">
		<div class="d-flex flex-column card h-100">
			<div class="display-10">cost</div>
			<p-skeleton *ngIf="!metrics.loadComplete" width="100%" height="4rem"></p-skeleton>
			<div class="display-6 d-flex flex-column" *ngIf="metrics.loadComplete">
				<div class="ms-2">
					{{ metrics.cost | currency }}
				</div>

				<div *ngIf="metrics.costPercent < metrics.historicalCostPercent" class="fl-text-success display-14 mt-auto ms-2">
					{{ metrics.historicalCostPercent | percent }} <fa-icon [icon]="['fas', 'down']"></fa-icon> last {{ metrics.recordsRemaining }} days
				</div>
				<div *ngIf="metrics.costPercent === 0" class="fl-text-secondary display-14 mt-auto ms-2">
					{{ metrics.historicalCostPercent | percent }} <fa-icon [icon]="['fas', 'hyphen']"></fa-icon> last {{ metrics.recordsRemaining }} days
				</div>
				<div *ngIf="metrics.costPercent > metrics.historicalCostPercent" class="fl-text-danger display-14 my-auto ms-2">
					{{ metrics.historicalCostPercent | percent }} <fa-icon [icon]="['fas', 'up']"></fa-icon> last {{ metrics.recordsRemaining }} days
				</div>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-md-4" style="max-height: 250px">
		<div class="d-flex flex-column card h-100">
			<div class="display-10">highest cost item</div>
			<p-skeleton *ngIf="!metrics.loadComplete" width="100%" height="4rem"></p-skeleton>
			<div class="display-8 d-flex flex-column h-100" *ngIf="metrics.highestCostItemSummary">
				{{ metrics.highestCostItemSummary?.name }}
				<div *ngIf="metrics.highestCostItemSummary" class="fl-text-danger display-14 mt-auto ms-2">
					{{ metrics.highestCostItemSummary.cost | currency }} {{ metrics.highestCostItemSummary.quantity }} sold
				</div>
			</div>
			<div class="d-flex flex-column h-100" *ngIf="metrics.loadComplete && !metrics.highestCostItemSummary">
				<div class="my-auto display-14">No items with food cost found</div>
			</div>
		</div>
	</div>
</div>

<div class="p-grid">
	<div class="p-col-12 p-md-3">
		<div class="d-flex flex-column card h-100">
			<div class="display-10 mb-3">by sales group</div>
			<p-skeleton *ngIf="!metrics.loadComplete" width="100%" height="10rem"></p-skeleton>
			<canvas
				baseChart
				[data]="itemDoughnut.data"
				[options]="itemDoughnut.options"
				[type]="itemDoughnut.type"
				width="100%"
				(chartClick)="onDoughnutChartPieceSelect($event)"
			></canvas>
		</div>
	</div>
	<div class="p-col-12 p-md-9">
		<div class="d-flex flex-column card h-100">
			<div class="d-flex mb-3">
				<div class="display-10 my-auto">item performance</div>
				<div class="ms-auto">
					<p-selectButton
						[options]="itemListSortType"
						optionLabel="label"
						optionValue="value"
						[(ngModel)]="itemListSortTypeSelected"
					></p-selectButton>
				</div>
			</div>

			<p-skeleton *ngIf="!metrics.loadComplete" width="100%" height="10rem"></p-skeleton>
			<app-item-performance-view
				*ngIf="metrics.loadComplete"
				[itemSummary]="currentDaySalesSummary.itemSummary"
				[sortType]="itemListSortTypeSelected"
				height="45rem"
			></app-item-performance-view>
		</div>
	</div>
</div>
